import messages from "@smartmixin/i18n/dist/translations/hr.json";

export default messages;
